import { gql } from '@apollo/client'

export const UPDATE_THEME_PREFERENCE = gql`
  mutation ($themePreference: ThemePreference!) {
    updateThemePreference(themePreference: $themePreference) {
      id
    }
  }
`
